import React, { useState } from 'react';
import { makeStyles, useTheme } from 'utils/makeStylesAdapter';
import { Box, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import TimelineIcon from '@mui/icons-material/Timeline';
import { HeaderModal, ButtonConsensus } from 'components';
import { Timeline as CustomTimeline } from './components';
import colorsSteps from 'utils/colorsSteps';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import { changeNameStep } from 'utils/changeNameStep';
import { useUserTypes } from 'hooks/useUserTypes';
import { useParameterKeys } from 'hooks/useParameterKeys';
import pmService from 'services/PM/pmService';
import associationService from 'services/association/associationService';
import associationRepresentativeService from 'services/associationRepresentative';
import inquiryService from 'services/inquiries/inquiryService';
import { USER_TYPE } from 'constants/inquirys/userType';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(0, 0, 1, 0),
  },
  timelineItem: {
    '&:before': {
      content: 'none',
    },
  },
}));

const ButtonTimeline = props => {
  const { transitions, inquiry } = props;

  const classes = useStyles();
  const { isMPDFT, applyLightTheme } = useParameterKeys();

  const customerConfig = useSelector(state => state.customerConfig);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const { isPM, userType } = useUserTypes();

  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);

  const selectedColor = isMPDFT && applyLightTheme ? '#000000' : '#ffffff';

  const fixedTransition = {
    createdAt: inquiry.createdAt,
    toStep: 'Criação do inquérito',
  };

  const handleOpen = () => {
    if (isPM) {
      pmService.getHistoryInquiryPmService(inquiry.id).then(response => {
        setEvents(response.data);
      });
    } else {
      if (userType === USER_TYPE.AssociationRepresentative) {
        associationRepresentativeService.getInvestigatedHistoryService(inquiry.id).then(response => {
          setEvents(response.data);
        });
      } else {
        inquiryService.getHistoryInquiryService(inquiry.id).then(response => {
          setEvents(response.data);
        });
      }
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
        <ButtonConsensus
          title="Histórico"
          endIcon={<TimelineIcon style={{ color: selectedColor }} />}
          backgroundColor={`${colorsSteps[inquiry.step]}`}
          hovercolor={`${colorsSteps[inquiry.step]}`}
          onClick={handleOpen}
          style={{ color: selectedColor }}
        />
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        scroll="body"
        aria-labelledby="modal-timeline"
      >
        <HeaderModal onClose={handleClose}>Histórico do inquérito</HeaderModal>
        <DialogContent>
          <DialogContentText>
            <Timeline>
              {transitions.length > 0 ? (
                transitions.map((transition, index) => (
                  <TimelineItem className={classes.timelineItem} key={index}>
                    <TimelineSeparator>
                      <Tooltip
                        title={`${changeNameStep(transition.toStep, customerConfig)}`}
                        arrow
                        placement="top"
                      >
                        <TimelineDot
                          style={{ backgroundColor: `${colorsSteps[transition.toStep]}` }}
                        >
                          <LaptopMacIcon fontSize="small" style={{ color: 'transparent' }} />
                        </TimelineDot>
                      </Tooltip>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <CustomTimeline
                        events={events[index] && events[index].events}
                        transition={transition}
                      />
                    </TimelineContent>
                  </TimelineItem>
                ))
              ) : (
                <TimelineItem className={classes.timelineItem}>
                  <TimelineSeparator>
                    <Tooltip title={`Criação do inquérito`} arrow placement="top">
                      <TimelineDot style={{ backgroundColor: `${colorsSteps.NAO_IDENTIFICADO}` }}>
                        <LaptopMacIcon fontSize="small" style={{ color: 'transparent' }} />
                      </TimelineDot>
                    </Tooltip>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <CustomTimeline transition={fixedTransition} />
                  </TimelineContent>
                </TimelineItem>
              )}
            </Timeline>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ButtonTimeline;
